<template>
  <div class="page-wrapper">
    <div class="item" v-for="(item,index) in pageData" :key="'keyA'+index">
      <img class="head-img"  :src="item.houseTypeHeaderImage || housetypedefault" alt="项目头图">
      <a class="name" @click.stop="showItem(item)">{{item.houseTypeName}}</a>
      <div class="desc">{{item.houseTypeRooms||0}}室{{item.houseTypeHall ||0}}厅{{item.houseTypeBathroom}}卫--{{item.houseTypeArea}}㎡ </div>
    </div>
    <type-detail :data="showData" :n="n"></type-detail>
  </div>
</template>
<script>
  import TypeDetail from './TypeDetail'
  import {housetypelist} from "../../../../../api/project";
  import housetypedefault from '../../../../../assets/housetypedefault.png'

  export default {
    name:'TypeInfo',
    props:{
      projectFid: {
        type: String,
        default: null
      }
    },
    components:{
      TypeDetail
    },
    // name: "TypeInfo",
    data(){
      return {
        n:0,
        pageData:[],
        showData:{},
        housetypedefault:housetypedefault
      }
    },
    watch:{
      projectFid(){
        this.housetypelist()
      }
    },
    methods:{
      housetypelist(){
        if(!this.projectFid){
          return
        }
        let params={
          projectFid:this.projectFid
        }
        housetypelist(params).then(res=>{
          if(!res.data) {
            return
          }
          this.pageData=res.data
        })
      },
      showItem(item){
        this.showData=item
        this.n++
      }
    },
    created(){
      this.housetypelist()
    }
  }
</script>
<style scoped>
  .item{
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .head-img{
    display: block;
    width: 260px;
    height: 170px;
    margin-bottom: 5px;
  }
  .name{
    display: block;
    line-height: 2;
    font-weight: bold;
    color: #444444;
  }

</style>
